import React, {useEffect, useState} from "react";
import StatementListItem from "./statement-list-item";

export default function EntryList({
                                      name,
                                      entries,
                                      zeroValuesShown,
                                      expandedAllCount,
                                      collapsedAllCount,
                                      handleToggleAccountDetails
                                  }) {
    const entryKeys = Object.keys(entries ?? {});

    const [collapsedSection, setCollapsedSection] = useState({});

    function handleToggleCollapseSectionClick(name) {
        const collapsedSectionUpdate = Object.assign({}, collapsedSection);

        if (collapsedSectionUpdate[name]) {
            delete collapsedSectionUpdate[name];
        } else {
            collapsedSectionUpdate[name] = name;
        }

        setCollapsedSection(collapsedSectionUpdate);
    }

    useEffect(() => {
        if (expandedAllCount) {
            setCollapsedSection({});
        }
    }, [expandedAllCount]);

    useEffect(() => {
        if (collapsedAllCount) {
            setCollapsedSection(entryKeys.reduce((memo, key) => {
                memo[key] = key;
                return memo;
            }, {}));
        }
    }, [collapsedAllCount]);

    return (
        <div>
            <div className="text-2xl flex items-center border-b border-tm-gray-200 py-2 pl-2">
                {name}
            </div>

            {entryKeys.map(incomeListName => {
                return <StatementListItem
                    key={incomeListName}
                    name={incomeListName}
                    statement={entries}
                    zeroValuesShown={!zeroValuesShown}
                    isSectionCollapsed={!!collapsedSection[incomeListName]}
                    onToggleSectionClick={() => handleToggleCollapseSectionClick(incomeListName)}
                    expandedAllCount={expandedAllCount}
                    collapsedAllCount={collapsedAllCount}
                    handleToggleAccountDetails={handleToggleAccountDetails}
                />
            })}
        </div>
    )
}

